// Deterministic vivid color from a string (used for logo fallbacks).
// Same name always gives the same color, but the palette is bright and varied.
const PALETTE = [
  '#F97316', // orange
  '#F43F5E', // rose
  '#EC4899', // pink
  '#D946EF', // fuchsia
  '#A855F7', // purple
  '#8B5CF6', // violet
  '#6366F1', // indigo
  '#3B82F6', // blue
  '#0EA5E9', // sky
  '#06B6D4', // cyan
  '#14B8A6', // teal
  '#10B981', // emerald
  '#22C55E', // green
  '#84CC16', // lime
  '#EAB308', // yellow
  '#F59E0B', // amber
  '#EF4444', // red
  '#0F766E', // dark teal
  '#7E22CE', // dark purple
  '#0D9488', // dark cyan
];

const hash = (str) => {
  let h = 5381;
  for (let i = 0; i < str.length; i++) {
    h = ((h << 5) + h) + str.charCodeAt(i);
    h |= 0;
  }
  return Math.abs(h);
};

export const colorFromName = (name) => {
  if (!name) return '#0F172A';
  return PALETTE[hash(name) % PALETTE.length];
};
